import React, { Fragment } from 'react';
import { Link,withRouter,matchPath } from 'react-router-dom';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { SITENAMEALIAS, SITENAME, LOGO } from '../utils/init';
import { showToast,showHttpError,showConfirm } from '../utils/library';
import Swal from 'sweetalert2'



 class UserAction extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            action : '',
            flag : 0,       
        };

    }



    /* Method defination for hadling action */
    handleAction = () => {
        let action = this.state.action;
        let flag = this.state.flag;
        if(action == 'mail-confirmed'){
            if(action != undefined){
                if(flag == '1'){
                    Swal.fire({
                        title: 'Success.',
                        text: "Email confirmed.",
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Get Started!',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                      }).then((result) => {
                        this.props.history.push('/get-started')
                    })
                }else{
                    Swal.fire(
                        'Sorry',
                        'Something is not right! You may have used a old email-verification email.',
                        'error'
                      )
                }
            }
        }else if(action == 'bank-account-updated'){
            if(action != undefined){
                if(flag == '1'){
                    Swal.fire({
                        title: 'Success.',
                        text: "Bank Account Updated.",
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'View Details',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                      }).then((result) => {
                        this.props.history.push('/get-started')
                    })
                }else{
                    Swal.fire(
                        'Sorry',
                        'Something is not right! You may have used a old email-verification email.',
                        'error'
                      )
                }
            }
        }else{
            if(action != undefined){
                if(flag == '2' || flag == '3' || flag == '4' || flag == '5'){
                    Swal.fire({
                        title: 'Success.',
                        text: "Wallet Info Updated.",
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'View Details',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                      }).then((result) => {
                        this.props.history.push('/get-started')
                    })
                }else{
                    Swal.fire(
                        'Sorry',
                        'Something is not right! You may have used a old email-verification email.',
                        'error'
                      )
                }
            }
        }
    }
   

   

   componentDidMount(){
    const match = matchPath(this.props.history.location.pathname, {
        path: "/user-action/:param1/:param2",
        exact: true,
        strict: false
    })
        this.setState({
            action: match.params.param1,
            flag : match.params.param2,
        },()=>{
            this.handleAction();
        })
   }


    render() {
        return (
            <Fragment>
                <div className="pb-0 login-background">
                    <div className="row mb-3">
                        <div className="col-4"></div>
                        <div className="col-4">
                            <img src={LOGO} width="288" height="47" className="logo-cred"/>
                        </div>
                        <div className="col-4"></div>
                    </div>
                </div>
                <Loader show={this.state.showLoader} />
            </Fragment>

        )
    }

    

}

export default withRouter(UserAction);

